import React from 'react'
import { connect } from 'react-redux'
import { Table, Button, Icon } from 'semantic-ui-react'
import CustomLoader from '../../elements/CustomLoader'
import ReactJson from 'react-json-view'
import { RED, GREEN } from '../../constants/colors'
import { sortByAttr } from '../../helpers/arrayHelpers'

const VERSION = 'version'

class ShopOrderHistory extends React.Component {
  state = { includeOrderVersions: false }

  componentDidMount() {
    const shopOrderId = this.props.match.params.id

    this.props.dispatch({
      type: 'SHOP_ORDER_AI_HISTORY_LOAD_SAGA',
      payload: { id: shopOrderId }
    })
    this.props.dispatch({
      type: 'SHOP_ORDER_VERSIONS_LOAD_SAGA',
      payload: { id: shopOrderId }
    })
    this.props.dispatch({ type: 'SHOP_ORDER_STATES_LOAD_SAGA' })
  }

  handleToggleOrderHistory = () => {
    this.setState({ includeOrderVersions: !this.state.includeOrderVersions})
  }

  render() {
    const { loading, history, versions } = this.props
    const { includeOrderVersions } = this.state
    let items = history
    if (includeOrderVersions) items = items.concat(versions)

    if (loading) return <CustomLoader />

    return (
      <div className="shop-order-history-container">
        <h3>Auto Integrate History:</h3>

        <input
          type="checkbox"
          onChange={this.handleToggleOrderHistory}
          checked={includeOrderVersions}
          className='cursor-pointer'
          style={{marginBottom: '10px'}}
        />
        <small
          onClick={this.handleToggleOrderHistory}
          className='cursor-pointer'
          style={{paddingLeft: '5px'}}
        >
          Include Order Paper Trail
        </small>

        <Table
          fixed singleLine striped celled
          className='sortable-table'
          style={{border: 0}}
        >
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Created At</Table.HeaderCell>
              <Table.HeaderCell>Type</Table.HeaderCell>
              <Table.HeaderCell>Payload</Table.HeaderCell>
              <Table.HeaderCell>Success</Table.HeaderCell>
              {includeOrderVersions && <Table.HeaderCell>Order status change</Table.HeaderCell>}
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {sortByAttr(items, 'created_at').map(item => {
              {/* Dynamically create a state attr to control if the item's payload is displayed */}
              const displayJson = `displayJSON-${item.id}`
              return (
                <React.Fragment key={`ai-row-${item.id}`}>
                  <Table.Row style={item.klass === VERSION ? { backgroundColor: '#BFE6FF' } : {}}>
                    <Table.Cell>{item.pretty_created_at}</Table.Cell>
                    <Table.Cell>{item.activity_type}</Table.Cell>
                    <Table.Cell style={{cursor: 'pointer'}}>
                      <Button
                        primary={!this.state[displayJson]}
                        secondary={this.state[displayJson]}
                        onClick={() => this.setState({[displayJson]: !this.state[displayJson]})}
                      >
                        {`${this.state[displayJson] ? 'Close' : 'View'}`}
                      </Button>
                    </Table.Cell>
                    <Table.Cell style={{textAlign: 'center'}}>
                      <Icon
                        size='large'
                        name={item.success ? 'check circle' : 'minus circle'}
                        style={{color: item.success ? GREEN : RED}}
                      />
                    </Table.Cell>
                    {includeOrderVersions &&
                      <Table.Cell>
                        {item.statusChange && <div>{item.statusChange}</div>}
                      </Table.Cell>
                    }
                  </Table.Row>
                  {this.state[displayJson] &&
                    <Table.Row key={`ai-details-row-${item.id}`}>
                      <Table.Cell></Table.Cell>
                      <Table.Cell></Table.Cell>
                      <Table.Cell>
                        <ReactJson
                          src={JSON.parse(item.payload)}
                          name={null}
                          displayDataTypes={false}
                          indentWidth={2}
                        />
                        <div style={{marginTop: '10px'}}>
                          <Button
                            secondary
                            onClick={() => this.setState({[displayJson]: !this.state[displayJson]})}
                          >
                            Close
                          </Button>
                        </div>
                      </Table.Cell>
                      <Table.Cell></Table.Cell>
                      {includeOrderVersions && <Table.Cell></Table.Cell>}
                    </Table.Row>
                  }
                </React.Fragment>
              )
            })}
          </Table.Body>
        </Table>
      </div>
    )
  }
} // ShopOrderHistory

const mapStateToProps = (state) => {
  const { states } = state.shopOrderStates
  const { versions } = state.versions

  return {
    loading: state.application.isLoading,
    history: state.autoIntegrate.history,
    versions: states.length === 0 ? versions : versions.map(version => {

      const stateChange = JSON.parse(version.payload)["state_id"]

      let obj = {
        ...version,
        activity_type: 'order_paper_trail',
        success: true,
        klass: VERSION
      }

      if (stateChange) obj['statusChange'] = stateChange.map(sc => states[sc] || "--")[1]

      return obj
    })
  }
}

export default connect(mapStateToProps)(ShopOrderHistory)
